export const GLOBAL_COUNTRY = 'Global';
export const STATUS_OK: number = 200;
export const STATUS_REDIRECT: number = 300;
